import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
	width: 100%;
`;

export const ImageWrapper = styled.div`
	width: 100%;
	max-height: 206px;
	margin-bottom: 6px;

	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
`;

export const Image = styled.img`
	max-height: 206px;
`;

export const ChipRow = styled.div`
	margin: 6px 0;
`;

export const Chip = styled.div`
	display: inline-block;
	padding: 6px 8px;
	border-radius: 100px;

	font-size: 14px;
	line-height: 19px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};

	background-color: ${({ theme }) => theme.colors.transparent.light10};
`;

export const Description = styled.p`
	margin: 6px 0 4px;

	font-size: 16px;
	line-height: 22px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.body};
`;

export const FooterRow = styled.div`
	padding: 12px 0;
	display: flex;
	align-items: center;
`;

export const FooterLeft = styled.div`
	display: flex;
	gap: 8px;
`;

export const AmountPickerWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;

	padding-right: 8px;
	margin-right: 8px;
	border-right: 1px solid ${({ theme }) => theme.colors.transparent.light30};
`;

export const AmountButton = styled.button<{ $isDisabled: boolean }>`
	width: 27px;
	height: 27px;

	svg {
		width: 27px;
		height: 27px;
		fill: ${({ theme }) => theme.colors.control.secondary};
	}

	${({ $isDisabled }) =>
		$isDisabled &&
		css`
			cursor: default;
			pointer-events: none;

			svg {
				fill: ${({ theme }) => theme.colors.control.dark};
			}
		`}
`;

export const TicketAmount = styled.div`
	font-size: 20px;
	line-height: 27px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};

	display: flex;
	align-items: center;
	gap: 6px;
`;

export const TicketIconWrapper = styled.div`
	width: 24px;
	height: 24px;

	svg {
		width: 24px;
		height: 24px;
		fill: ${({ theme }) => theme.colors.icon.secondary};
	}
`;

export const TicketCost = styled.div`
	font-size: 20px;
	line-height: 27px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};

	display: flex;
	align-items: center;
	gap: 6px;
`;

export const PmPointsIcon = styled.div`
	width: 24px;
	height: 24px;

	svg {
		width: 24px;
		height: 24px;
		fill: ${({ theme }) => theme.colors.icon.main};

		rect {
			fill: ${({ theme }) => theme.colors.icon.main};
		}
	}
`;

export const FooterRight = styled.div`
	margin-left: auto;

	display: flex;
	gap: 16px;
`;
